import { ClientType } from "src/api/v1/project-ApiSlice";
import { Fragment, useEffect, useState } from "react";
import { ErrorBoundary } from "src/components/ErrorBoundary/ErrorBoundary";
import { IMAGE_HOST } from "src/utils/constants";
import { Products } from "src/pages/OfferPage/FunctionDescription/Category/SubCategory/Products/Products";
import DOMPurify from "dompurify";


export const SubCategory = (
    props: {
      key: number,
      subCategory: any,
      clientType: ClientType
    }
) => {
  const { subCategory, clientType } = props;

  const [hasDescription, setHasDescription] = useState(false);

  useEffect(() => {
    function checkDescription(subCategory: any) {
      if (
          subCategory.descriptions[clientType].desc !== null &&
          subCategory.descriptions[clientType].desc !== ''
      ) {
        return true;
      }

      if (subCategory.products && Object.keys(subCategory.products).length) {
        return Object.values(subCategory.products).some((product: any) =>
            product.descriptions[clientType] && product.descriptions[clientType].desc !== null &&
            product.descriptions[clientType] && product.descriptions[clientType].desc !== ''
        )
      }
      return false;
    }

    setHasDescription(checkDescription(subCategory));

  }, [subCategory, clientType]);

  return subCategory && hasDescription ? (
      <Fragment>
        <ErrorBoundary>
          {subCategory.base_image ? (
              <img
                  src={`${IMAGE_HOST}${subCategory.base_image}`}
                  style={{
                    width: "100%",
                    paddingTop: 15,
                    paddingBottom: 20,
                  }}
              />
          ) : null}
          <div className="break-inside-avoid">
            <h4 style={{
              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
              letterSpacing: "-0.154px",
            }}
                className="break-after-avoid"
            >{subCategory.name}</h4>
            <div
                style={{
                  paddingTop: 5,
                  paddingBottom: 10,
                }}
                className="break-inside-avoid"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(subCategory.descriptions[clientType].desc),
                }}
            />
          </div>
        </ErrorBoundary>
        <Products products={subCategory.products} clientType={clientType} />
      </Fragment>
  ) : null;
};
